/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 18/5/2023
 */

import React from "react";
import {
  Box,
  ButtonGroup,
  IconButton,
  List,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { PaginationDetails } from "../../Utils/Utils";
import styles from "./BrPriv.module.css";
import {
  openDeleteBrPrivModal,
  openEditBrPrivModal,
} from "../../Store/Slices/brPrivSlice";

const BrPrivTable = ({ data }) => {
  const dispatch = useDispatch();
  const dataSet = Array.isArray(data) ? data : [];

  const { page, count, handleChange, _DATA } = PaginationDetails(dataSet);

  const roles = sessionStorage.getItem("roles");

  return (
    <>
      <TableContainer className={styles.container}>
        <Table
          stickyHeader
          aria-label="br privilege mappings table"
          className={styles.table}
        >
          <TableHead>
            <TableRow>
              <TableCell width={100}>Id</TableCell>
              <TableCell width={200}>Role</TableCell>
              <TableCell width={200}>Privilege</TableCell>
              <TableCell align="center" width={"30%"}>
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {_DATA.currentData()?.map((mapping) => (
              <TableRow className={styles.row} key={mapping.brId}>
                <TableCell className={styles.tCell} component="th" scope="row">
                  #{mapping.brId}
                </TableCell>
                <TableCell className={styles.tCell}>{mapping.brName}</TableCell>
                <TableCell className={styles.tCell}>
                  <List>
                    {mapping.secPrivDTOS?.map((priv) => (
                      <Typography key={priv.privId}>{priv.privName}</Typography>
                    ))}
                  </List>
                </TableCell>
                <TableCell className={styles.tCell} align="center">
                  <ButtonGroup variant="text" aria-label="text button group">
                    {roles?.split(",").includes("PRIV_ES_EDIT_MAPPING") ? (<IconButton
                      onClick={() => {
                        dispatch(openEditBrPrivModal(mapping.brId));
                      }}
                    >
                      <Edit />
                    </IconButton>) : null}
                    {roles?.split(",").includes("PRIV_ES_DELETE_MAPPING") ?  (<IconButton
                      onClick={() => {
                        dispatch(openDeleteBrPrivModal(mapping.brId));
                      }}
                    >
                      <Delete />
                    </IconButton>) : null}
                  </ButtonGroup>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box my={2} display="flex" justifyContent="center">
        <Pagination
          count={count}
          size="large"
          page={page}
          variant="outlined"
          color="primary"
          onChange={handleChange}
          className={styles.pagination}
        />
      </Box>
    </>
  );
};

export default BrPrivTable;
